import { displayFontFamily } from "styles/theme";

const INK = "#0E3A2A";
const INK_MUTED = "#6B7770";
const LILAC_SOFT = "#EDE6FA";
const LILAC_INK = "#6F4FBF";
const CARD_BORDER = "#DCD2F0";
const ROW_BORDER = "#E7DEF6";
const HAIRLINE_STRONG = "#D8CCB2";

const styles = {
  card: {
    background: "linear-gradient(180deg, #F7F4FC 0%, #FCFBFE 55%)",
    border: `1px solid ${CARD_BORDER}`,
    borderRadius: "20px",
    p: "22px",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    mb: "14px",
  },
  headerIconCircle: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    background: LILAC_SOFT,
    color: LILAC_INK,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    fontSize: 18,
  },
  suggestionsCount: {
    background: LILAC_SOFT,
    color: LILAC_INK,
    fontWeight: 700,
    fontSize: 12,
    borderRadius: "999px",
    px: "9px",
    py: "3px",
    flexShrink: 0,
  },
  headerTitle: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: 22,
    letterSpacing: "-0.4px",
    color: INK,
    lineHeight: 1.2,
  },
  headerSub: {
    fontSize: 13.5,
    color: INK_MUTED,
    lineHeight: 1.45,
    mt: "4px",
  },
  recList: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    mt: "18px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    p: "10px 8px 10px 12px",
    borderRadius: "12px",
    background: "rgba(255,255,255,0.7)",
    border: `1px solid ${ROW_BORDER}`,
  },
  rowIconCircle: {
    width: 32,
    height: 32,
    borderRadius: "9px",
    background: "#fff",
    border: `1px solid ${ROW_BORDER}`,
    color: LILAC_INK,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    fontSize: 14,
  },
  rowTitle: {
    fontWeight: 600,
    fontSize: 13.5,
    color: INK,
    lineHeight: 1.2,
  },
  rowDesc: {
    fontSize: 12,
    color: INK_MUTED,
    lineHeight: 1.35,
    mt: "2px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  rowCta: {
    flexShrink: 0,
    px: "14px",
    py: "7px",
    fontSize: 12.5,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "999px",
    color: INK,
    border: `1px solid ${HAIRLINE_STRONG}`,
    background: "transparent",
    "&:hover": {
      background: "#F4F0E7",
      borderColor: HAIRLINE_STRONG,
    },
  },
  footer: {
    mt: "14px",
  },
  dontShowAgain: {
    alignSelf: "flex-start",
    fontSize: 11.5,
    fontWeight: 600,
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: INK_MUTED,
    px: "14px",
    py: "8px",
    border: `1px solid ${HAIRLINE_STRONG}`,
    borderRadius: "999px",
    background: "transparent",
    "&:hover": {
      background: "#F4F0E7",
      color: INK,
    },
  },
};

export default styles;
